import React, { useEffect, useState } from "react";
import { BiSolidTrashAlt } from "react-icons/bi";
import { RiAddLine } from "react-icons/ri";
import { TextField } from "@mui/material";
import * as Styles from "./styles";
import MaterialUI from "../../../../../../../material-UI";

interface Props {
  onClose: () => void;
  desconto: string;
  setDesconto: (value: string) => void;
  mutate?: any;
  refetch: any;
  isLoading: boolean;
  isSuccess: boolean;
  reset3: () => void;
}

const Footer: React.FC<Props> = (props) => {
  const [value, setValue] = useState("");

  const formatCurrency = (value: string) => {
    const cleanedValue = value.replace(/\D/g, "");
    const formattedValue = (Number(cleanedValue) / 100).toFixed(2);
    return `${formattedValue
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  };

  const inputDesconto = (value: string) => {
    setValue(value);
    props.setDesconto(value);
  };

  const handleClick = () => {
    props.mutate();
  };

  useEffect(() => {
    if (props.isSuccess) {
      props.onClose();
      props.refetch();
      props.reset3();
    }
  }, [props.isSuccess]);

  return (
    <>
      <Styles.Container>
        <TextField
          placeholder="%"
          fullWidth
          margin="normal"
          size="small"
          onChange={(e) => inputDesconto(formatCurrency(e.target.value))}
          value={value}
        />
      </Styles.Container>
      <Styles.SecondContainer>
        <Styles.Button onClick={props?.onClose}>
          <Styles.LightTextBlue>Voltar</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.ButtonBlue
          onClick={() => {
            handleClick();
          }}
        >
          {props.isLoading ? (
            <MaterialUI.CircularProgress size={22} style={{ color: "#fff" }} />
          ) : (
            <Styles.LightText>Inserir desconto {">"}</Styles.LightText>
          )}
        </Styles.ButtonBlue>
      </Styles.SecondContainer>
    </>
  );
};

export default Footer;
